import { action } from 'mobx';
import { ImportReferenceUploadForm } from 'application/import-reference/forms';
import { BaseEditViewStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { ImportReferenceService } from 'application/import-reference/services';

@applicationContext
class ImportReferenceUploadViewStore extends BaseEditViewStore {
    constructor(rootStore) {
        const importReferenceService = new ImportReferenceService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'file',
            Form: ImportReferenceUploadForm,
            actions: () => {
                return {
                    create: async () => {
                        var file = this.form.fields.get("file").files[0];
                        await importReferenceService.upload({file: file});
                    }
                }
            },
            FormClass: ImportReferenceUploadForm,
        });
    }

    @action.bound
    async createResource(resource) {
        if (!this.actions.create) return;
        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            await this.actions.create(resource);
            this.form.setFieldsDisabled(false);
            await this.rootStore.routerStore.goBack();
            await setTimeout(() => this.rootStore.notificationStore.success('Import reference updated successfully.'), 10);
        }
        catch(err) {
            this.form.setFieldsDisabled(false);
            this.rootStore.notificationStore.error(err && err.data && err.data.Message ? err.data.Message : 'Error occured while trying to update the import reference.');
        }
    }

    @action.bound
    async onInit({ initialLoad }) {
        if(!initialLoad) {
            this.rootStore.routerStore.goBack();
        }
    }
}

export default ImportReferenceUploadViewStore;
